// Anasayfadaki (harita sayfası) hızlı giriş kartı.
//
// Ziyaretçi siteye girdiğinde haritanın yanında hem giriş yapabilir hem de
// "üye değil misin, hemen kaydol" bağlantısıyla kayıt sayfasına geçebilir.
// Oturum açıksa kart, kullanıcıyı kendi paneline / yönetim merkezine götüren
// bir kısayola dönüşür.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useUser } from "../../UserContext";
import useLogin, { LOGIN_SCOPES, routeAfterLogin } from "../../hooks/useLogin";
import { isManagementRole } from "../../utils/roleManagement";
import "./homeLoginCard.css";

const HomeLoginCard = () => {
  const { user } = useUser();
  const { submit, errorMessage, redirectHint, isSubmitting, resetError } = useLogin({
    scope: LOGIN_SCOPES.MEMBER,
  });

  const [form, setForm] = useState({ username: "", password: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errorMessage) resetError();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.username.trim() || !form.password || isSubmitting) return;
    submit(form);
  };

  if (user) {
    return (
      <section className="home-login" aria-label="Hesabım">
        <p className="home-login__eyebrow">Hoş geldin</p>
        <h3 className="home-login__title">{user.fullName || user.username}</h3>
        <p className="home-login__text">
          Panelinden profilini, takımını ve başvurularını yönetebilirsin.
        </p>
        <Link className="home-login__submit" to={routeAfterLogin(user)}>
          {isManagementRole(user.role) ? "Yönetim Paneline Git" : "Panelime Git"}
        </Link>
      </section>
    );
  }

  return (
    <section className="home-login" aria-label="Kullanıcı girişi">
      <p className="home-login__eyebrow">Kullanıcı Girişi</p>
      <h3 className="home-login__title">Hesabına giriş yap</h3>

      <form className="home-login__form" onSubmit={handleSubmit} noValidate>
        <label className="home-login__field">
          <span>Kullanıcı adı</span>
          <input
            name="username"
            type="text"
            value={form.username}
            onChange={handleChange}
            placeholder="Kullanıcı adınız"
            autoComplete="username"
          />
        </label>

        <label className="home-login__field">
          <span>Şifre</span>
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Şifreniz"
            autoComplete="current-password"
          />
        </label>

        {errorMessage && (
          <p className="home-login__error" role="alert">
            {errorMessage}
            {redirectHint && (
              <>
                {" "}
                <Link to={redirectHint.to}>{redirectHint.label}</Link>
              </>
            )}
          </p>
        )}

        <button
          type="submit"
          className="home-login__submit"
          disabled={isSubmitting || !form.username.trim() || !form.password}
        >
          {isSubmitting ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>

      <p className="home-login__register">
        Üye değil misin? <Link to="/kayit-ol">Hemen kaydol</Link>
      </p>

      {/* Bu kart yalnızca üye girişidir. Yönetim kapısı ziyaretçiye ne bağlantı
          ne de uyarı metniyle duyurulur; yanlış hesapla denendiğinde sunucunun
          döndürdüğü yönlendirme yalnızca o anda gösterilir. */}

      {/* Yönetim giriş bağlantısı bilerek yok: anasayfa yalnızca üye girişidir,
          yönetim kapısı ziyaretçilere duyurulmaz. */}
      <p className="home-login__links">
        <Link to="/sifremi-unuttum">Şifremi unuttum</Link>
      </p>
    </section>
  );
};

export default HomeLoginCard;
